export const PODPayloadFechtMetaData = {
  searchFilterDtoList: [
    {
      description: "Ricerca1",
      daAAndOr: 1,
      fields: [
        {
          operator: 1,
          multiple: null,
          name: "Aoo",
          className: "FieldBaseForSearchAooDto",
          value: "ARCESE",
        },
        {
          operator: 3,
          valore1: {
            id: 142,
            type2: 142,
            type3: 0,
            documentType: 67,
            idParent: 67,
            key: "OPE.POD",
          },
          valore2: null,
          multiple: null,
          name: "DocumentType",
          className: "FieldBaseForSearchDocumentTypeDto",
        },
        {
          operator: 2,
          valore1: "Non Valido",
          multiple: null,
          name: "Stato",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "DocName",
          description: "Oggetto",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "Creation_Date",
          description: "Data registrazione:",
          className: "FieldBaseForSearchDateTimeDto",
        },
        {
          operator: 3,
          valore1: 180,
          valore2: null,
          multiple: null,
          name: "Creation_Date_NrGiorni",
          description: "Data reg. indietro di:",
          className: "FieldBaseForSearchIntDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Originale",
          description: "Nome file:",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 4,
          valore1: 34000000,
          valore2: null,
          multiple: null,
          name: "DocNumber",
          description: "System Id:",
          className: "FieldBaseForSearchIntDto",
        },

        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "TESTO225_131",
          externalId: "COD_SPEDIZIONE",
          description: "OPE - Codice Spedizione",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 3,
          valore1: null,
          multiple: "20",
          name: "TESTO265_131",
          externalId: "COD_ORDINE",
          description: "OPE - Codice Ordine",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 3,
          multiple: "T2",
          name: "TESTO246_136",
          externalId: "MITTENTI_DESTINATARI",
          description: "Mittenti Destinatari",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TESTO417_299",
          externalId: "TRANSPORT_ORDER_KEY",
          description: "Transport Order Key / Descr Committente",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          multiple: "2024RV338612",
          name: "TESTO227_131",
          externalId: "COD_VIAGGIO",
          description: "OPE - Codice Viaggio Consegna",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "COMBO221_131",
          externalId: "TIPO_DOCUMENTO",
          description: "OPE - Tipo Documento",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: null,
          valore2: null,
          multiple: null,
          name: "NUMERIC60_8",
          externalId: "SEQUENZA_DOC",
          description: "Revisione Doc",
          className: "FieldBaseForSearchIntDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          multiple: "110MI",
          name: "TESTO266_131",
          externalId: "ID_COMPANY",
          description: "OPE - ID Company Dest",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "DATA224_131",
          externalId: "DATAORAFOTO",
          description: "OPE - Data/Ora Foto",
          className: "FieldBaseForSearchDateTimeDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TESTO223_131",
          externalId: "ACCOUNT",
          description: "OPE - Account",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 3,
          multiple: "VLM;MOBILE",
          name: "COMBO222_131",
          externalId: "ORIGINE_FILE",
          description: "OPE - Origine File",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
       
      ],
    },
  ],
  selectFilterDto: {
    fields: [
      {
        fieldType: 0,
        selected: true,
        name: "STATO",
        index: 1,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WORKFLOW",
        index: 0,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WFVERSIONSTATE",
        index: 999,
        orderBy: null,
      },
      {
        fieldType: 0,
        selected: true,
        name: "FORMATO",
        index: 2,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNUMBER",
        index: 3,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CLASSEDOC",
        index: 5,
        orderBy: {
          index: 0,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNAME",
        index: 11,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CREATION_DATE",
        index: 4,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      /*  {
        fieldType: 0,
        selected: true,
        name: "AUTOREDESCRIPTION",
        index: 6,
        orderBy: {
          index: 0,
          direction: 0,
        },
      }, */
      {
        fieldType: 2,
        selected: true,
        name: "COMBO221_131",
        index: 8,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "COMBO222_131",
        index: 9,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "DATA224_131",
        index: 16,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "MULTI336_142",
        index: 17,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "NUMERIC60_8",
        index: 10,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO223_131",
        index: 12,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO227_131",
        index: 14,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO246_136",
        index: 15,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO265_131",
        index: 13,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "ORIGINALE",
        index: 7,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "NOTE",
        index: 18,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "REVISIONE",
        index: 19,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
    ],
    maxItems: 50,
  },
};
export const PKLPayloadFechtMetaData = {
  searchFilterDtoList: [
    {
      description: "Ricerca1",
      daAAndOr: 1,
      fields: [
        {
          operator: 1,
          multiple: null,
          name: "Aoo",
          className: "FieldBaseForSearchAooDto",
          value: "ARCESE",
        },
        {
          operator: 3,
          valore1: {
            id: 142,
            type2: 142,
            type3: 0,
            documentType: 67,
            idParent: 67,
            key: "OPE.POD",
          },
          valore2: null,
          multiple: null,
          name: "DocumentType",
          className: "FieldBaseForSearchDocumentTypeDto",
        },
        {
          operator: 2,
          valore1: "Non Valido",
          multiple: null,
          name: "Stato",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "DocName",
          description: "Oggetto",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "Creation_Date",
          description: "Data registrazione:",
          className: "FieldBaseForSearchDateTimeDto",
        },
        {
          operator: 3,
          valore1: 180,
          valore2: null,
          multiple: null,
          name: "Creation_Date_NrGiorni",
          description: "Data reg. indietro di:",
          className: "FieldBaseForSearchIntDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Originale",
          description: "Nome file:",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 4,
          valore1: 34000000,
          valore2: null,
          multiple: null,
          name: "DocNumber",
          description: "System Id:",
          className: "FieldBaseForSearchIntDto",
        },

        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "TESTO225_131",
          externalId: "COD_SPEDIZIONE",
          description: "OPE - Codice Spedizione",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          valore1: null,
          multiple: "PKL",
          name: "TESTO265_131",
          externalId: "COD_ORDINE",
          description: "OPE - Codice Ordine",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          multiple: "PKL_GENERAL",
          name: "TESTO246_136",
          externalId: "MITTENTI_DESTINATARI",
          description: "Mittenti Destinatari",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TESTO417_299",
          externalId: "TRANSPORT_ORDER_KEY",
          description: "Transport Order Key / Descr Committente",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          multiple: "2024RV338612",
          name: "TESTO227_131",
          externalId: "COD_VIAGGIO",
          description: "OPE - Codice Viaggio Consegna",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "COMBO221_131",
          externalId: "TIPO_DOCUMENTO",
          description: "OPE - Tipo Documento",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: null,
          valore2: null,
          multiple: null,
          name: "NUMERIC60_8",
          externalId: "SEQUENZA_DOC",
          description: "Revisione Doc",
          className: "FieldBaseForSearchIntDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 1,
          multiple: "110MI",
          name: "TESTO266_131",
          externalId: "ID_COMPANY",
          description: "OPE - ID Company Dest",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "DATA224_131",
          externalId: "DATAORAFOTO",
          description: "OPE - Data/Ora Foto",
          className: "FieldBaseForSearchDateTimeDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TESTO223_131",
          externalId: "ACCOUNT",
          description: "OPE - Account",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 3,
          multiple: "VLM;MOBILE",
          name: "COMBO222_131",
          externalId: "ORIGINE_FILE",
          description: "OPE - Origine File",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        
      ],
    },
  ],
  selectFilterDto: {
    fields: [
      {
        fieldType: 0,
        selected: true,
        name: "STATO",
        index: 1,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WORKFLOW",
        index: 0,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WFVERSIONSTATE",
        index: 999,
        orderBy: null,
      },
      {
        fieldType: 0,
        selected: true,
        name: "FORMATO",
        index: 2,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNUMBER",
        index: 3,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CLASSEDOC",
        index: 5,
        orderBy: {
          index: 0,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNAME",
        index: 11,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CREATION_DATE",
        index: 4,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "AUTOREDESCRIPTION",
        index: 6,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "COMBO221_131",
        index: 8,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "COMBO222_131",
        index: 9,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "DATA224_131",
        index: 16,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "MULTI336_142",
        index: 17,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "NUMERIC60_8",
        index: 10,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO223_131",
        index: 12,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO227_131",
        index: 14,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO246_136",
        index: 15,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO265_131",
        index: 13,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "ORIGINALE",
        index: 7,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "NOTE",
        index: 18,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "REVISIONE",
        index: 19,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
    ],
    maxItems: 50,
  },
};

export const PODPayloadBufferIds = {
  document: {
    bufferIds: ["e8ea89f0223440429a84987f2c7f1749"],
  },
  fields: [
    {
      value: "ARCESE",
      name: "Aoo",
      className: "BusinessUnitFieldDTO",
    },
    {
      value: 142,
      name: "DocumentType",
      className: "DocumentTypeFieldDTO",
    },
    {
      value: "Profilo Parziale",
      name: "Stato",
      className: "StateFieldDTO",
    },
    {
      value: 1,
      name: "Origine",
      className: "OriginFieldDTO",
    },
    {
      value: "Test per chiamata Arxivar",
      name: "DocName",
      className: "SubjectFieldDTO",
    },
    {
      value: "test.pdf",
      name: "Originale",
      className: "OriginalFieldDTO",
    },

    {
      value: "2024RV157660",
      name: "TESTO265_131",
      externalId: "COD_ORDINE",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "",
      name: "TESTO246_136",
      externalId: "MITTENTI_DESTINATARI",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "2024RV335440",
      name: "TESTO227_131",
      externalId: "COD_VIAGGIO",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "POD",
      name: "COMBO221_131",
      externalId: "TIPO_DOCUMENTO",
      className: "AdditionalFieldComboDTO",
    },
    {
      value: 1,
      name: "NUMERIC60_8",
      externalId: "SEQUENZA_DOC",
      className: "AdditionalFieldIntDTO",
    },
    {
      value: "110MI",
      name: "TESTO266_131",
      externalId: "ID_COMPANY",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "2024-12-13 16:34:00.000",
      name: "DATA224_131",
      externalId: "DATAORAFOTO",
      className: "AdditionalFieldDateTimeDTO",
    },
    {
      value: "r.sala@reply.it",
      name: "TESTO223_131",
      externalId: "ACCOUNT",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "VLM",
      name: "COMBO222_131",
      externalId: "ORIGINE_FILE",
      className: "AdditionalFieldComboDTO",
    },
  ],
};

export const VehicleDocumentBufferIds = {
  document: {
    bufferIds: ["efec53c9682a403888c7cbcc31975a25"],
  },
  fields: [
    {
      value: "ARCESE",
      name: "Aoo",
      className: "BusinessUnitFieldDTO",
    },
    {
      value: 386,
      name: "DocumentType",
      className: "DocumentTypeFieldDTO",
    },
    {
      value: "VALID",
      name: "Stato",
      className: "StateFieldDTO",
    },
    {
      value: 1,
      name: "Origine",
      className: "OriginFieldDTO",
    },
    {
      value: "Prova Rel 2", //Descrizione doc
      name: "DocName",
      className: "SubjectFieldDTO",
    },
    {
      value: "rel2.pdf",
      name: "Originale", //Nome file
      className: "OriginalFieldDTO",
    },
    {
      value: "AA999BB", //TARGA
      name: "TESTO200_111",
      externalId: "TARGA",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "33944", //LEGACYCODE ES. 33944
      name: "TESTO248_131",
      externalId: "SUPPLIER_EXTERNAL_CODE_STR",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "aaaaaa", //ACCOUNT ID CE
      name: "TESTO426_3",
      externalId: "SUPPLIER_CODE",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "RELEASE 2 SPA", //RAGIONE SOCIALE
      name: "TABLE130_74",
      externalId: "SUPPLIER_COMPANY_NAME",
      className: "AdditionalFieldComboDTO",
    },
    {
      value: "VLM",
      name: "COMBO222_131",
      externalId: "ORIGINE_FILE",
      className: "AdditionalFieldComboDTO",
    },
  ],
};

export const VectorDeclarationBufferIds = {
  document: {
    bufferIds: ["efec53c9682a403888c7cbcc31975a25"],
  },
  fields: [
    {
      value: "ARCESE",
      name: "Aoo",
      className: "BusinessUnitFieldDTO",
    },
    {
      value: 385,
      name: "DocumentType",
      className: "DocumentTypeFieldDTO",
    },
    {
      value: "VALID",
      name: "Stato",
      className: "StateFieldDTO",
    },
    {
      value: 1,
      name: "Origine",
      className: "OriginFieldDTO",
    },
    {
      value: "Prova Rel 2 Vecto", //Descrizione doc
      name: "DocName",
      className: "SubjectFieldDTO",
    },
    {
      value: "rel2Vecto.pdf",
      name: "Originale", //Nome file
      className: "OriginalFieldDTO",
    },
    {
      value: "AA999BB", //TARGA
      name: "TESTO200_111",
      externalId: "TARGA",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "33944", //LEGACYCODE ES. 33944
      name: "TESTO248_131",
      externalId: "SUPPLIER_EXTERNAL_CODE_STR",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "aaaaaa", //ACCOUNT ID CE
      name: "TESTO426_3",
      externalId: "SUPPLIER_CODE",
      className: "AdditionalFieldStringDTO",
    },
    {
      value: "RELEASE 2 SPA", //RAGIONE SOCIALE
      name: "TABLE130_74",
      externalId: "SUPPLIER_COMPANY_NAME",
      className: "AdditionalFieldComboDTO",
    },
    {
      value: "VLM",
      name: "COMBO222_131",
      externalId: "ORIGINE_FILE",
      className: "AdditionalFieldComboDTO",
    },
  ],
};

export const VehicleDocumentFetchMetaData = {
  searchFilterDtoList: [
    {
      description: "Ricerca1",
      daAAndOr: 1,
      fields: [
        {
          operator: 1,
          multiple: null,
          name: "Aoo",
          className: "FieldBaseForSearchAooDto",
          value: "ARCESE",
        },
        {
          operator: 3,
          valore1: {
            id: 386,
            type3: 386,
            documentType: 83,
            key: "QFT.VLM.CDC",
          },
          valore2: null,
          multiple: null,
          name: "DocumentType",
          className: "FieldBaseForSearchDocumentTypeDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Stato",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "DocName",
          description: "Oggetto",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "Creation_Date",
          description: "Data registrazione:",
          className: "FieldBaseForSearchDateTimeDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Originale",
          description: "Nome file:",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 4,
          valore1: 34000000,
          valore2: null,
          multiple: null,
          name: "DocNumber",
          description: "System Id:",
          className: "FieldBaseForSearchIntDto",
        },
        {
          operator: 1,
          valore1: null,
          multiple: "AA999BB", //mettere qui la targa
          name: "TESTO200_111",
          externalId: "TARGA",
          description: "TARGA",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: null,
          multiple: null, //mettere qui il account id CE
          name: "TESTO426_3",
          externalId: "SUPPLIER_CODE",
          description: "Codice Anagrafica ERP",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: "33944", //legacy code
          name: "TESTO248_131",
          externalId: "SUPPLIER_EXTERNAL_CODE_STR",
          description: "Codice Anagrafica TMS (String)",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TABLE130_74",
          externalId: "SUPPLIER_COMPANY_NAME",
          description: "Denominazione Fornitore",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
      ],
    },
  ],
  selectFilterDto: {
    fields: [
      {
        fieldType: 0,
        selected: true,
        name: "STATO",
        index: 1,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WORKFLOW",
        index: 0,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WFVERSIONSTATE",
        index: 999,
        orderBy: null,
      },
      {
        fieldType: 0,
        selected: true,
        name: "FORMATO",
        index: 2,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNUMBER",
        index: 3,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CLASSEDOC",
        index: 5,
        orderBy: {
          index: 0,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNAME",
        index: 11,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CREATION_DATE",
        index: 4,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "AUTOREDESCRIPTION",
        index: 6,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO200_111",
        index: 8,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO248_131",
        index: 9,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO426_3",
        index: 16,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TABLE130_74",
        index: 17,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "ORIGINALE",
        index: 7,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
    ],
    maxItems: 50,
  },
};
export const VectorDeclarationFetchMetaData = {
  searchFilterDtoList: [
    {
      description: "Ricerca1",
      daAAndOr: 1,
      fields: [
        {
          operator: 1,
          multiple: null,
          name: "Aoo",
          className: "FieldBaseForSearchAooDto",
          value: "ARCESE",
        },
        {
          operator: 3,
          valore1: {
            id: 385,
            type3: 385,
            documentType: 83,
            key: "QFT.VLM.VECTO",
          },
          valore2: null,
          multiple: null,
          name: "DocumentType",
          className: "FieldBaseForSearchDocumentTypeDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Stato",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "DocName",
          description: "Oggetto",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 0,
          valore1: "0001-01-01T00:00:00",
          multiple: null,
          name: "Creation_Date",
          description: "Data registrazione:",
          className: "FieldBaseForSearchDateTimeDto",
        },
        {
          operator: 0,
          valore1: null,
          multiple: null,
          name: "Originale",
          description: "Nome file:",
          className: "FieldBaseForSearchStringDto",
        },
        {
          operator: 4,
          valore1: 34000000,
          valore2: null,
          multiple: null,
          name: "DocNumber",
          description: "System Id:",
          className: "FieldBaseForSearchIntDto",
        },
        {
          operator: 1,
          valore1: null,
          multiple: "AA999BB", //mettere qui la targa
          name: "TESTO200_111",
          externalId: "TARGA",
          description: "TARGA",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          valore1: null,
          multiple: null, //mettere qui il account id CE
          name: "TESTO426_3",
          externalId: "SUPPLIER_CODE",
          description: "Codice Anagrafica ERP",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: "33944", //legacy code
          name: "TESTO248_131",
          externalId: "SUPPLIER_EXTERNAL_CODE_STR",
          description: "Codice Anagrafica TMS (String)",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
        {
          operator: 0,
          multiple: null,
          name: "TABLE130_74",
          externalId: "SUPPLIER_COMPANY_NAME",
          description: "Denominazione Fornitore",
          className: "FieldBaseForSearchStringDto",
          isAdditional: true,
          visible: true,
        },
      ],
    },
  ],
  selectFilterDto: {
    fields: [
      {
        fieldType: 0,
        selected: true,
        name: "STATO",
        index: 1,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WORKFLOW",
        index: 0,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "WFVERSIONSTATE",
        index: 999,
        orderBy: null,
      },
      {
        fieldType: 0,
        selected: true,
        name: "FORMATO",
        index: 2,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNUMBER",
        index: 3,
        orderBy: {
          index: 1,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CLASSEDOC",
        index: 5,
        orderBy: {
          index: 0,
          direction: 1,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "DOCNAME",
        index: 11,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "CREATION_DATE",
        index: 4,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "AUTOREDESCRIPTION",
        index: 6,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO200_111",
        index: 8,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO248_131",
        index: 9,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TESTO426_3",
        index: 16,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 2,
        selected: true,
        name: "TABLE130_74",
        index: 17,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
      {
        fieldType: 0,
        selected: true,
        name: "ORIGINALE",
        index: 7,
        orderBy: {
          index: 0,
          direction: 0,
        },
      },
    ],
    maxItems: 50,
  },
};
